<div *ngIf="job" [formGroup]="form">
    <!--(swipeleft)="swipe(tabs.activeId, 'LEFT')" (swiperight)="swipe(tabs.activeId, 'RIGHT')"-->
    <!--ng-container *ngTemplateOutlet="tabHeader"></ng-container-->
    <div class="table-responsive" formArrayName="jobLines">
        <table class="table table-hover" [ngClass]="{'table-sm': isMobile | async }">
            <thead class="thead-light">
                <tr>
                    <th
                        [class]="lineTypeIdClass | async"
                        translate="JobLine.ItemID"
                    ></th>
                    <th
                        class="d-md-table-cell d-none w-40"
                        translate="JobLine.Description"
                    ></th>
                    <th
                        *ngIf="exchangeMode && (isMobile | async) === false"
                        translate="Job.Resource"
                    ></th>
                    <th
                        *ngIf="canChangePayment"
                        translate="JobLine.Payment"
                    ></th>
                    <th
                        class="text-right pl-0"
                        [translate]="
                            showDelivered
                                ? 'JobLine.Ordered'
                                : 'JobLine.Quantity'
                        "
                    ></th>
                    <th
                        *ngIf="showDelivered"
                        class="text-right pl-0"
                        translate="JobLine.Delivered"
                    ></th>
                    <th
                        class="text-right pl-0 w-10"
                        translate="JobLine.Amount"
                    ></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let line of jobLines?.controls;
                        let i = index;
                        let last = last
                    "
                    [formGroupName]="i"
                >
                    <td [class]="lineTypeIdClass | async" [ngSwitch]="true" [style.line-height]="(isMobile | async) ? '1rem' : 'unset'">
                        <input
                            *ngSwitchCase="baseLabour(line)"
                            abiTypeahead
                            abiStock="LAB"
                            [mode]="baseLabourMode"
                            [preLoad]="true"
                            formControlName="itemId"
                            (selectItem)="showStock($event.item, line)"
                            abiProductHint="JobLine.SelectLabour"
                            [parentId]="stockParentId"
                            inputDisplay="code"
                        />
                        <input
                            *ngSwitchCase="baseTravel(line)"
                            abiTypeahead
                            abiStock="TRV"
                            [mode]="baseTravelMode"
                            [preLoad]="true"
                            formControlName="itemId"
                            (selectItem)="showStock($event.item, line)"
                            abiProductHint="JobLine.SelectTravel"
                            [parentId]="stockParentId"
                            inputDisplay="code"
                        />
                        <ng-container *ngSwitchDefault>
                            <a
                                *ngIf="canEditLine(line); else readOnlyLine"
                                href=""
                                (click)="editJobLine(line, i)"
                                >{{
                                    codeOnly(line.getRawValue()["itemId"]) ||
                                        ("Job.ClickToAdd" | translate)
                                }}
                            </a>
                            <ng-template #readOnlyLine>
                                {{ codeOnly(line.getRawValue()["itemId"]) }}
                            </ng-template>
                        </ng-container>
                        <br class="d-table-cell d-md-none" />
                        <small class="d-table-cell d-md-none">{{
                            lineDescription1(line)
                        }}</small>
                    </td>
                    <td class="d-md-table-cell d-none w-40">
                        {{ lineDescription1(line) }}
                    </td>
                    <td *ngIf="exchangeMode && (isMobile | async) === false">
                        {{ line.getRawValue().resourceId }}
                    </td>
                    <td
                        *ngIf="canChangePayment"
                    >
                        <select class="custom-select" formControlName="mode">
                            <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType">{{ paymentType }}</option>
                        </select>
                    </td>
                    <td class="text-right pl-0" [ngSwitch]="true">
                        <button
                            *ngSwitchCase="baseLabour(line)"
                            [abiToggle]="line.getRawValue()['quantityOrdered']"
                            [disabled]="line.get('quantityOrdered').disabled"
                            (click)="toggleLabour(line)"
                        ></button>
                        <input
                            *ngSwitchCase="baseTravel(line)"
                            type="text"
                            mask="separator.0"
                            formControlName="quantityOrdered"
                            class="px-1"
                            class="text-right d-inline-block"
                            [style.width]="'46px'"
                        />
                        <span *ngSwitchDefault>
                            {{ line.getRawValue()["quantityOrdered"] }}
                        </span>
                    </td>
                    <td *ngIf="showDelivered" class="text-right pl-0">
                        <button
                            [abiToggle]="
                                line.getRawValue()['quantityDelivered']
                            "
                            (click)="deliverLine(line)"
                            [disabled]="line.get('quantityDelivered').disabled"
                        ></button>
                    </td>
                    <td class="text-right pl-0">
                        <span
                            *hasClaim="
                                'JobLineShow' +
                                line.getRawValue()['typeId'] +
                                'Price'
                            "
                        >
                            {{
                                line.getRawValue()["amount"] | number : "1.2-2"
                            }}
                        </span>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="">
                        <button
                            *ngIf="
                                job?.unpaid &&
                                showDelivered &&
                                canMarkPaid &&
                                codJob
                            "
                            type="button"
                            class="btn btn-primary"
                            (click)="markPaid()"
                        >
                            {{ "JobCod.ManualPayment" | translate }}
                        </button>
                    </td>

                    <td class="d-md-table-cell d-none w-40">
                    </td>
                    <td *ngIf="exchangeMode && (isMobile | async) === false">
                    </td>
                    <td
                        *ngIf="canChangePayment"
                    >
                    </td>
                    <td class="text-right pl-0" [ngSwitch]="true">
                    </td>
                    <td class="text-right pl-0" [colSpan]="showDelivered ? '2' : '1'">
                        <strong *hasClaim="lineClaims()">{{
                            totalAmount | number : "1.2-2"
                        }}</strong>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>

<ng-template #paidDialog>
    <h5 mat-dialog-title>{{ "JobCod.ManualPayment" | translate }}</h5>
    <div mat-dialog-content [formGroup]="payment" class="mt-2 pt-2 row">
        <abi-form-field cols="col-12" label="JobLine.Receipt">
            <input type="text" formControlName="receipt" />
        </abi-form-field>
        <abi-form-field cols="col-12" label="JobLine.Paid">
            <input
                type="number"
                formControlName="paid"
                [min]="0"
                [max]="job?.unpaid"
            />
        </abi-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">Cancel</button>
        <button
            [disabled]="payment.invalid"
            mat-button
            [mat-dialog-close]="true"
        >
            OK
        </button>
    </div>
</ng-template>
